import { tinyMCEInit, apiKey } from './config'
import { connect } from 'react-redux'
import TinyEditor from './component'

const mapStateToProps = (state, props) => ({
  init: tinyMCEInit,
  apiKey: apiKey,
  article: props.article,
  onEditorChange: props.onEditorChange
})


export default connect(mapStateToProps)(TinyEditor)